export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6101.7da31909.jpg";